import {
    $get,
    $post
  } from '@/utils/http'
  // 系统设置
export default {
    // 系统设置
  getSys() {
 
    return $post('/portal/websitadmin/websiteIntroduction/listIntroduction')
   
    },
  
  
  }
  